import constant from '../../../../utils/constant';
export default constant({
    ERROR: 'error',
    WARNING: 'warning',
    INFO: 'info',
    SUCCESS: 'success'
});
